import * as React from 'react';
import { useLayoutEffect, useRef, useState } from 'react';
import { RequiredChildrenProps } from '../app/types/appTypes';
import Footer from './Footer';
import HeaderNav from './HeaderNav';

const Layout: React.FC<RequiredChildrenProps> = ({ children }) => {
  const footerRef = useRef<HTMLDivElement>(null);
  const [footerHeight, setFooterHeight] = useState(0);

  useLayoutEffect(() => {
    function refreshSize() {
      setFooterHeight(footerRef.current?.clientHeight || 0);
    }

    window.addEventListener('resize', refreshSize);
    refreshSize();
    return () => window.removeEventListener('resize', refreshSize);
  }, []);

  return (
    <div style={{ minHeight: '100vh', position: 'relative' }}>
      <div className="bg-gradient-to-r from-emerald-50 to-emerald-100">
        <HeaderNav className=" py-3" />
      </div>
      <main style={{ paddingBottom: `${footerHeight}px` }}>{children}</main>
      <Footer
        ref={footerRef}
        style={{
          position: 'absolute',
          bottom: 0,
          width: '100%',
        }}
      />
    </div>
  );
};

export default Layout;
